var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNewOwner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6044 10.8978C12.8902 10.124 12.0236 9.5065 11.059 9.08415C10.0945 8.6618 9.05292 8.44376 7.99995 8.44376C6.94698 8.44376 5.90541 8.6618 4.94086 9.08415C3.97631 9.5065 3.10966 10.124 2.3955 10.8978C2.28524 11.0197 2.22356 11.1778 2.22217 11.3422V14.0089C2.22451 14.1842 2.29577 14.3514 2.42055 14.4746C2.54532 14.5977 2.71355 14.6667 2.88883 14.6667H13.1111C13.2879 14.6667 13.4574 14.5964 13.5825 14.4714C13.7075 14.3464 13.7777 14.1768 13.7777 14V11.3333C13.7742 11.172 13.7126 11.0174 13.6044 10.8978Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99978 7.55557C9.718 7.55557 11.1109 6.16267 11.1109 4.44445C11.1109 2.72624 9.718 1.33334 7.99978 1.33334C6.28156 1.33334 4.88867 2.72624 4.88867 4.44445C4.88867 6.16267 6.28156 7.55557 7.99978 7.55557Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewOwner);
export default __webpack_public_path__ + "static/media/icon--new-owner.a66251fa15dae6aa3004c97e2f96ba9a.svg";
export { ForwardRef as ReactComponent };